import { PlatformFinanceRepository } from '@lib/api/repository/platform-finance';
import { PlatformFinanceFilters } from '@lib/types/platform-finance';

export default class PlatformFinanceService {
  constructor(private repository: PlatformFinanceRepository) {}

  dashboard(filters: PlatformFinanceFilters, signal?: AbortSignal) {
    return this.repository.dashboard(filters, signal);
  }
}
